import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { addFavoriteMutate } from 'queries';
import { reducer } from 'actions/registry/fetch-installed-apps';

export default new AsyncActionHandler({
  name: 'add_favorite',
  stateProp: 'addFavorite',
  handler: (id) => async () => {
    const { data } = await apollo.mutate({
      mutation: addFavoriteMutate,
      variables: {
        id
      }
    });

    return {
      favorites: data.favorites
    };
  },
  reduce: reducer
});
